import React, { lazy, ReactElement, ReactNode, Suspense } from "react";
import { HashRouter, RouteObject, useRoutes } from "react-router-dom";
import { Container } from "@/globalStyle/index.style";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import LayoutCom from "@/page/Layout/Layout";
import Login from "@/page/Login";
import dayjs from "dayjs";

// 工具函数
const lazyModule = (moduleName: string) => {
    const Module = lazy(() => import(`@/page/${moduleName}/${moduleName}.tsx`));
    return <Module />;
};

const lazyFileModule = (fileName: string, moduleName: string) => {
    const Module = lazy(
        () => import(`@/page/${fileName}/${moduleName}/${moduleName}.tsx`)
    );
    return <Module />;
};
// const ProxyCenter = lazy(() => import("@/page/ProxyCenter"));
const UserList = lazy(() => import("@/page/UserManagement/UserList"));

const CircleOfFriends = lazy(
    () => import("@/page/UserManagement/CircleOfFriends")
);
const GroupManagement = lazy(
    () => import("@/page/UserManagement/GroupManagement")
);
const TodayData = lazy(() => import("@/page/TodayData"));
const NotFound = lazy(() => import("@/page/NotFound/NotFound"));


const RedEnvelopeRecord = lazy(
    () => import("@/page/SystemBilling/RedEnvelopeRecord")
);

const SoloRedEnvelopeRecord = lazy(
    () => import("@/page/SystemBilling/RedEnvelopeRecord/Solo")
);

const GroupRedEnvelopeRecord = lazy(
    () => import("@/page/SystemBilling/RedEnvelopeRecord/Group")
);

const TransferRecords = lazy(
    () => import("@/page/SystemBilling/TransferRecords")
);
const WithdrawalRecord = lazy(
    () => import("@/page/SystemBilling/WithdrawalRecord")
);
const WithdrawalRequest = lazy(
    () => import("@/page/SystemBilling/WithdrawalRequest")
);



const RolesList = lazy(() => import("@/page/Roles/RolesList"));
const AdminList = lazy(() => import("@/page/Roles/AdminList"));



const RechargeSetting = lazy(
    () => import("@/page/RechargeManagement/RechargeSetting")
);
const RechargeRequest = lazy(
    () => import("@/page/RechargeManagement/RechargeRequest")
);
const RechargeRecord = lazy(
    () => import("@/page/RechargeManagement/RechargeRecord")
);
const RechargeMoneyConfig = lazy(
    () => import("@/page/RechargeManagement/RechargeMoneyConfig")
);
const BankList = lazy(() => import("@/page/RechargeManagement/BankList"));

// 礼品积分兑换
const BonusPointExchange = lazy(
    () =>
        import("@/page/SystemBilling/BonusPoints/BonusPointExchangedDetails/index")
);

const Language = lazy(
    () =>
        import("@/page/SystemBilling/language/index")
);
const routes: RouteObject[] = [
    { path: "/login", element: <Login /> },

    { path: '/appPay', element: lazyModule("AppPay") },
    {
        path: "/",
        element: <LayoutCom />,
        children: [
            {
                path: "/substation",
                element: lazyModule("QTalkSubstation"),
            },
            { path: "/admin/dataCenter", element: <TodayData /> },
            {
                path: "/userManagement",
                children: [
                    {
                        path: "userList",
                        element: <UserList />,
                    },
                    {
                        path: "circleOfFriends",
                        element: <CircleOfFriends />,
                    },
                    {
                        path: "groupManagement",
                        element: <GroupManagement />,
                    },
                ],
            },
            {
                path: "/systemBilling",
                children: [
                    {
                        path: "redEnvelopeRecord",
                        element: <RedEnvelopeRecord />,
                    },
                    {
                        path: "soloRedEnvelopeRecord",
                        element: <SoloRedEnvelopeRecord />,
                    },
                    {
                        path: "groupRedEnvelopeRecord",
                        element: <GroupRedEnvelopeRecord />,
                    },
                    {
                        path: "transferRecords",
                        element: <TransferRecords />,
                    },
                    {
                        path: "withdrawalRecord",
                        element: <WithdrawalRecord />,
                    },
                    {
                        path: "withdrawalRequest",
                        element: <WithdrawalRequest />,
                    },
                    {
                        path: "bonusPointExchange",
                        element: <BonusPointExchange />,
                    },
                    // {
                    //     path: "changeLanguage",
                    //     element: <Language />
                    // },
                    {
                        path: "rechargeRecord",
                        element: <RechargeRecord />,
                    },
                    {
                        path: "cashAccountDetails",
                        element: lazyFileModule("SystemBilling", "cashAccountDetails"),
                    },
                    {
                        path: "giftAccountDetails",
                        element: lazyFileModule("SystemBilling", "giftAccountDetails"),
                    },
                    {
                        path: "cashToMarbles",
                        element: lazyFileModule("SystemBilling", "cashToMarbles"),
                    },
                    {
                        path: "marblesRecovery",
                        element: lazyFileModule("SystemBilling", "marblesRecovery"),
                    },
                    {
                        path: 'cashSaveDetails',
                        element: lazyFileModule("SystemBilling", "cashSaveDetails"),
                    },
                    {
                        path: 'verifyCodes',
                        element: lazyFileModule("SystemBilling", "verifyCodes"),
                    },

                ],
            },
            {
                path: "/systemSetting",
                children: [
                    {
                        path: "updateChatMessage",
                        element: lazyModule("UpdateChatMessage"),
                    },
                    {
                        path: "rolesList",
                        element: <RolesList />,
                    },
                    {
                        path: "adminList",
                        element: <AdminList />,
                    },
                    {
                        path: "eventManagement",
                        element: lazyFileModule("SystemSetting", "eventManagement")
                    },
                    {
                        path: 'chargeOptions',
                        element: lazyFileModule("SystemSetting", "chargeOption")
                    },
                    {
                        path: 'changeInTheGiftAccount',
                        element: lazyFileModule("SystemSetting", "changeInTheGiftAccount")
                    },
                    {
                        path: 'integralConfig',
                        element: lazyFileModule("SystemSetting", "integralConfig")
                    },
                ],
            },
            {
                path: "/rechargeManagement",
                children: [
                    {
                        path: "rechargeRecord",
                        element: <RechargeRecord />,
                    },
                    {
                        path: "rechargeSetting",
                        element: <RechargeSetting />,
                    },
                    {
                        path: "rechargeRequest",
                        element: <RechargeRequest />,
                    },
                    {
                        path: "bankList",
                        element: <BankList />,
                    },
                    {
                        path: "rechargeMoneyConfig",
                        element: <RechargeMoneyConfig />,
                    },
                ],
            },
            {
                path: '/merchantManagement',
                children: [
                    {
                        path: 'merchantList',
                        element: lazyFileModule("MerchantManagement", "merchantList")
                    },
                    {
                        path: 'merchantProductList',
                        element: lazyFileModule("MerchantManagement", "merchantProductList")
                    },
                    {
                        path: 'merchandiseAccountDetail',
                        element: lazyFileModule("MerchantManagement", "merchandiseAccountDetail")
                    },
                    {
                        path: 'salesperson',
                        element: lazyFileModule("MerchantManagement", "salesperson")
                    },
                    {
                        path: 'swiper',
                        element: lazyFileModule("MerchantManagement", "swiper")
                    },
                    {
                        path: 'subscriberExchangeRecord',
                        element: lazyFileModule("MerchantManagement", "subscriberExchangeRecord")
                    },
                    {
                        path: 'settlementRecord',
                        element: lazyFileModule("MerchantManagement", "settlementRecord")
                    },
                    {
                        path: 'applicationForSettlementList',
                        element: lazyFileModule("MerchantManagement", "applicationForSettlementList")
                    },
                    {
                        path: 'businessLicenseReview',
                        element: lazyFileModule("MerchantManagement", "businessLicenseReview")
                    },
                ]
            },
            {
                path: "/qrCodeManager",
                children: [
                    {
                        path: 'qrCodeBatch',
                        element: lazyFileModule("qrCodeManager", "qrCodeBatch")
                    },
                    {
                        path: 'qrCoderList',
                        element: lazyFileModule("qrCodeManager", "qrCoderList")
                    },
                ]
            },
        ],
    },
    { path: "*", element: <NotFound /> },
];

const BasicRouter = () => useRoutes(routes);

dayjs.locale("zh-cn");

const BaseRouter = () => {
    return (
        <ConfigProvider locale={zhCN}>
            <Container>
                <HashRouter>
                    <Suspense fallback={<div>Loading....</div>}>
                        <BasicRouter />
                    </Suspense>
                </HashRouter>
            </Container>
        </ConfigProvider>
    );
};

export default BaseRouter;
